// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconFiltering.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconFiltering = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M14.7045 2H1.27865C0.57203 2 0 2.57709 0 3.28996C0 4.00283 0.57203 4.57992 1.27865 4.57992H14.7213C15.428 4.57992 16 4.00283 16 3.28996C16 2.57709 15.4111 2 14.7045 2Z" />
    <path d="M12.6688 6.70156H3.31441C2.60778 6.70156 2.03575 7.27864 2.03575 7.99151C2.03575 8.70438 2.60778 9.28147 3.31441 9.28147H12.6856C13.3922 9.28147 13.9642 8.70438 13.9642 7.99151C13.9642 7.27864 13.3754 6.70156 12.6688 6.70156Z" />
    <path d="M10.633 11.4201H5.35016C4.64353 11.4201 4.0715 11.9972 4.0715 12.71C4.0715 13.4229 4.64353 14 5.35016 14H10.6498C11.3565 14 11.9285 13.4229 11.9285 12.71C11.9285 11.9972 11.3396 11.4201 10.633 11.4201Z" />
  </BaseIcon>
);

export default IconFiltering;
